import { all } from 'redux-saga/effects';

/* ------------- Sagas ------------- */
import membersSaga from '@/_store/modules/members/saga';
import authSaga from '@/_store/modules/auth/saga';
import motoboyInfoSaga from '@/_store/modules/motoboy-info/saga';

/* ------------- Connect Types To Sagas ------------- */

export default function* root(): Generator {
  yield all([authSaga, motoboyInfoSaga, membersSaga]);
}
